export const PREFERRED_DELIVERY = {
  Ground: 1,
  Expedited: 2,
  AmwayPremium: 3,
  HandDelivery: 4,
};
